import './Ticket.less';

import clsx from 'clsx';
import moment from 'moment';
import React from 'react';
import { useReframe } from 'nike-re-framejs';

import { formatCurrency } from '@/common/client';
import { isString } from '@/common/util';
import { getTicketWinValue } from '@/mytickets/utils';
import i18n from '@i18n';
import { formatStakeMoney } from '@/betslip/money';

import { cashinOfferByTicketId$$ } from 'nike-ui/src/components/turboLive/components/cashin/subs';
import { useIsCashinDisabled } from 'nike-ui/src/components/ticketus/cashin/useIsCashinDisabled';

const EUR = 'EUR';
const now = moment();
const nowText = i18n('jsp.homepage.datum.dnes');

function formatDate(date) {
    const momentDate = moment(date);
    if (!momentDate.isValid()) {
        return isString(date) ? date : '';
    }
    let hours = momentDate.format('HH:mm');
    let dateText = nowText;
    if (!momentDate.isSame(now, 'day')) {
        dateText = momentDate.format('DD.MM.');
    }
    return `${dateText}\u00a0${hours}`;
}

function getId(ticket) {
    let ret =
        ticket.alias ||
        // saved on profile
        (ticket.source === 'Saved' && ticket.ticketNoVisual) ||
        // placed (from detail)
        ticket.ticketNumber ||
        // saved on device
        ticket.barcode;
    // placed (from list)
    if (!ret && ticket.ticketId) {
        const match = /urn:be:ticket:(\d+):\d+/.exec(ticket.ticketId);
        ret = match && match.length ? match[1] : ret;
    }
    return ret;
}

const statusMapping = {
    // Podany bez statusu
    Registered: 'registered',
    // Nevyherny
    Lost: 'lost',
    // Stornovany
    Cancelled: 'cancelled',
    // Vyherny
    Won: 'winning',
    Win: 'winning',
    PaidOut: 'winning',
    CashinPaidOut: 'winning',
    // Vrateny s MP
    ReturnWon: 'returned',
    ReturnPaidOut: 'returned'
};

function getStatus(ticket) {
    return statusMapping[ticket.displayStatus];
}

export function useTicket(ticket, onClick, customerId, shouldCheckTicketOwner = false) {
    const { alias, hash, odds, submitDate, ticketId } = ticket;
    return {
        alias,
        id: getId(ticket),
        odds,
        stake: formatStakeMoney(ticket, customerId, shouldCheckTicketOwner),
        status: getStatus(ticket),
        submitDate: formatDate(submitDate),
        ticketId,
        title: getTicketWinValue(ticket, EUR),
        click(e) {
            e.preventDefault();
            if (onClick) {
                onClick({ hash, alias });
            }
        }
    };
}

export default function Ticket({ ticket, onClick }) {
    const { derefSub } = useReframe();
    const { alias, id, odds, stake, status, submitDate, ticketId, title, click } = useTicket(ticket, onClick);
    const ticketCashin = derefSub(cashinOfferByTicketId$$(ticketId));
    const isDisabled = useIsCashinDisabled(ticketCashin);
    const hasRunningCashin = ticketId && derefSub(['ticketus/cashin-offer/is-running', ticketId]);
    const isSavedTicket = ticket.source === 'Saved';

    return (
        <div className={clsx('ticket', status)} onClick={click}>
            <div className="border">
                <div className="ticket-data-row">
                    <div className={isSavedTicket ? 'saved-ticket-title' : 'ticket-title'}>{title}</div>
                    <span className={clsx({ alias })}>{id}</span>
                </div>
                <div className="ticket-data-row">
                    <div>
                        <span>{submitDate}</span>
                        <span>
                            {i18n('ticketus.ticket.betslipStake')}
                            <b className={isSavedTicket ? 'saved-ticket-title' : 'ticket-title'}>{stake}</b>
                        </span>
                    </div>
                    <span>
                        {i18n('ticketus.ticket.betslipOdds')}
                        <b className={isSavedTicket ? 'saved-ticket-title' : 'ticket-title'}>{odds}</b>
                    </span>
                </div>
                {hasRunningCashin && !isDisabled ? <i className="ticket-badge-cashin">{formatCurrency(EUR)}</i> : null}
            </div>
        </div>
    );
}
